import React, {Component} from "react"
import PropTypes from "prop-types"
import {match as Match} from "react-router-dom"

import {IndexRedirect, PartialRoute, withPartialRoute} from "@irati/utils/history/routing"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import AppContainer from "@irati/ui/src/AppContainer"
import SideNavigation from "@irati/ui/src/Navigation/SideNavigation"
import authentication from "@irati/auth"
import theme from "@irati/ui/src/global/theme"

import getMenuItems from "../components/AccountMenu/menuItems"
import {AccountWrapper} from "../components/Wrapper"
import getMobileMenuItems from "../components/AccountMenu/mobileMenuItems"
import UpdateUser from "../containers/UpdateUser"
import UpdateContactPreferences from "../containers/UpdateContactPreferences"
import UpdateUserPassword from "../containers/UpdateUserPassword"
import UpdateUserPayment from "../containers/UpdateUserPayment"
import Security from "../containers/Security"
import CategoriesCustomisation from "../containers/Customisation"

interface SettingsProps {
  match: Match
}

const Settings = ({match}: SettingsProps) => (
  <>
    <IndexRedirect to="password" />
    <PartialRoute match={match.url} path="/contact" component={UpdateContactPreferences} title="Contact Preferences" />
    <PartialRoute match={match.url} path="/password" component={UpdateUserPassword} title="Update Password" />
    <PartialRoute match={match.url} path="/security" component={Security} title="Security" />
    <PartialRoute match={match.url} path="/payment" component={UpdateUserPayment} title="Update Payment Details" />
    <PartialRoute match={match.url} path="/customisation/categories" component={CategoriesCustomisation} title="Customise my interests" />
  </>
)

interface AccountRoutesProps extends InjectIntl {
  path: string
}

class AccountRoutes extends Component<AccountRoutesProps> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {path, formatMessage} = this.props

    const menuItems = getMenuItems({
      showCustomisation: !!authentication.apps("perks"),
      platformApp: this.context.apps.PLATFORM
    })
    const mobileMenuItems = getMobileMenuItems({
      showCustomisation: !!authentication.apps("perks")
    })

    const accountProps = {
      indexRedirect: "profile",
      MobileMenu: () => <SideNavigation links={mobileMenuItems} />,
      mobileBack: formatMessage({id: "account.mobile.label"}),
      mobileBackLink: "/",
      Menu: () => <SideNavigation links={menuItems} />,
      usesNewSideNav: true
    }

    return (
      <AppContainer mainBackground={theme.colors.greys.white}>
        <AccountWrapper {...accountProps}>
          <IndexRedirect match={{url: path}} to="/" />
          <PartialRoute match={path} path="/profile" component={UpdateUser} title="Update Details" />
          <PartialRoute match={path} path="/settings" component={Settings} />
        </AccountWrapper>
      </AppContainer>
    )
  }
}

export default withPartialRoute(injectIntl(AccountRoutes))
